import * as React from 'react';
import { Col, Row } from 'antd';
import { observer } from 'mobx-react';

import { TextView } from 'src/core/ui/text.view';
import { BooleanView } from 'src/core/ui/boolean.view';
import { TimePickerView, DisableKind } from 'src/core/ui/timepicker.view';
import { PlaceEditorController } from 'src/app/general/places/parts/place-editor.controller';

interface OfficeGeneralPartViewProps extends ComponentViewProps<TransportCompanyOfficeItem> {
	mode: ControlMode;
}

@observer
export class OfficeGeneralPartView extends React.Component<OfficeGeneralPartViewProps, {}> {
	constructor(props) {
		super(props);
	}

	render() {
		const model = this.props.model;
		const mode = this.props.mode;
		return (
			<React.Fragment>
				<Row gutter={16}>
					<Col xs={24} lg={16}>
						<TextView
							required
							onGetErrorMessage={() => this.props.model.validate(false, 'title')}
							mode={mode}
							label="Title"
							value={model.title}
							onChanged={newVal => model.title = newVal}
						/>
					</Col>
					<Col xs={24} lg={8}>
						<TextView
							required
							onGetErrorMessage={() => this.props.model.validate(false, 'code')}
							mode={mode}
							label="Code"
							value={model.code}
							onChanged={newVal => model.code = newVal}
						/>
					</Col>
					<Col xs={24}>
						<PlaceEditorController
							mode={mode}
							required
							onGetErrorMessage={() => this.props.model.validate(false, 'placeId')}
							onChanged={(value) => {
								model.placeId = value != null ? value.id : null;
							}}
							value={model.placeId}
							label="Place"
							setBusy={this.props.setBusy}
							type={[1, 4]}
						/>
					</Col>
					<Col xs={24} lg={6}>
						<TimePickerView
							label="Opening Hour"
							required
							mode={this.props.mode}
							value={model.dynamicProperties['openingHour'] != null ? model.dynamicProperties['openingHour'] : null}
							onChanged={(value) => {
								model.dynamicProperties['openingHour'] = value;
							}}
							disableKind={DisableKind.disableSeconds}
							dateUsage="utc"
						/>
					</Col>
					<Col xs={24} lg={6}>
						<TimePickerView
							label="Closing Hour"
							required
							mode={this.props.mode}
							value={model.dynamicProperties['closingHour'] != null ? model.dynamicProperties['closingHour'] : null}
							onChanged={(value) => {
								model.dynamicProperties['closingHour'] = value;
							}}
							disableKind={DisableKind.disableSeconds}
							dateUsage="utc"
						/>
					</Col>
					<Col xs={24} lg={6}>
						<BooleanView
							value={model.canPickup}
							label="Can Pickup"
							onChanged={newVal => model.canPickup = newVal}
							mode={this.props.mode}
						/>
					</Col>
					<Col xs={24} lg={6}>
						<BooleanView
							value={model.canDropoff}
							label="Can Dropoff"
							onChanged={newVal => model.canDropoff = newVal}
							mode={this.props.mode}
						/>
					</Col>
					<Col xs={24}>
						<TextView
							mode={mode}
							label="Observations"
							value={model.dynamicProperties['observations']}
							onChanged={newVal => model.dynamicProperties['observations'] = newVal}
							rows={3}
						/>
					</Col>
				</Row>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/office/parts/officegeneral-part.view.tsx